import React from "react";
import AnimatedProgressBar, {
    type AnimatedProgressBarBackgroundColor,
    type AnimatedProgressBarColor,
} from "../../styleguide/AnimatedProgressBar/AnimatedProgressBar";

interface ProgressBarProps {
    backgroundColor?: AnimatedProgressBarBackgroundColor;
    isFetchingData?: boolean;
    noMarginTop?: boolean;
    standByColor?: AnimatedProgressBarColor;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
    isFetchingData,
    backgroundColor = "light-grey",
    standByColor = "white",
    noMarginTop,
}: ProgressBarProps) => (
    <>
        {isFetchingData && <AnimatedProgressBar backgroundColor={backgroundColor} noMarginTop={noMarginTop} />}
        {!isFetchingData && (
            <AnimatedProgressBar backgroundColor={standByColor} color={standByColor} noMarginTop={noMarginTop} />
        )}
    </>
);

export default ProgressBar;
